import React, {useContext, useEffect, useMemo, useState} from "react";
import {
  Autocomplete,
  Box, Checkbox, Divider,
  FormControl, FormControlLabel,
  IconButton, InputLabel, MenuItem, Select, Slider,
  Stack,
  TextField, Tooltip,
  Typography
} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconArrowsDiagonal, IconPlus, IconX} from "@tabler/icons-react";
import {v4 as uuidv4} from "uuid";
import {PersonaModal} from "../../../../../components/modals/PersonaModal";
import {WebSettingsContext} from "../../../../../context/WebSettingsContext";
import {TopicRepository} from "../../../../../repositories/TopicRepository";
import {UserInputSettings} from "../settings/components/user-input-settings";
import {HookSettings} from "../settings/HookSettings";

export const SettingsToolsTab = ({node, setNode, onUpdate, project, nodes}) => {
  const {settings} = useContext(WebSettingsContext);


  const onChangeData = (key, value) => {
    setNode(prev => {
      const state = {...node};
      state.data[key] = value;

      return state;
    })
  }

  const {primary, secondary} = menuItemsInfo.settings_tools;

  const selectedTools = useMemo(() => {
    return project?.tools?.filter(i => node?.data?.tools && node?.data?.tools?.includes(i?.id)) || []
  }, [node?.data?.tools, project?.tools])

  return (
    <>
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>
      {/*<HookSettings*/}
      {/*  node={node} setNode={setNode} project={project} onUpdate={onUpdate} onChangeData={onChangeData}*/}
      {/*/>*/}

      <Divider />
      <Box>
        <Typography fontWeight={700} fontSize={13}>Select function to execute</Typography>
        <Autocomplete
          renderInput={(props) => <TextField {...props} size={"small"}/>}
          options={project?.tools} multiple
          getOptionLabel={option => option?.function?.name}
          value={selectedTools || []}
          onChange={(e, newValue) => onChangeData("tools", newValue?.map(i => i?.id))}
        />
      </Box>


      <CustomParamData
        node={node} setNode={setNode} project={project}
        nodes={nodes}
        onChangeData={onChangeData}
        onUpdate={onUpdate}
      />
    </>
  )
}

const CustomParamData = ({node, setNode, project, onChangeData, onUpdate}) => {

  return (
    <>
      <Stack direction={"row"} gap={2} justifyContent={"space-between"} alignItems={"center"}>
        <Typography fontWeight={700} fontSize={13}>Custom Params</Typography>

        <Tooltip title={"Add Custom Param"}>
          <IconButton
            variant={"outlined"} color={"secondary"} size={"small"}
            onClick={() => {
              setNode(prev => {
                const state = {...prev};
                if (!state?.data?.custom_params) {
                  state.data.custom_params = {}
                }
                const id = uuidv4();
                state.data.custom_params[id] = "";
                return state
              })
            }}
          >
            <IconPlus size={18}/>
          </IconButton>
        </Tooltip>
      </Stack>
      {
        node?.data?.custom_params &&
        Object.keys(node?.data?.custom_params)?.sort()
          ?.map((custom_param_key, index) => {
            return (
              <Stack
                direction={"row"}
                gap={1}
                key={custom_param_key}
              >
                <TextField
                  size={"small"}
                  min={0}
                  defaultValue={custom_param_key}
                  InputLabelProps={{shrink: true}}
                  sx={{flex: 1}}
                  onBlur={(e) => {
                    setNode(prev => {
                      const state = {...prev};
                      if (!state?.data?.custom_params) {
                        state.data.custom_params = {}
                      }
                      const value = state.data.custom_params[custom_param_key] || "";
                      delete state.data.custom_params[custom_param_key];
                      state.data.custom_params[e.target.value] = value;
                      onUpdate(state)
                      return state
                    })
                  }}
                />

                <TextField
                  size={"small"}
                  min={0}
                  value={node.data.custom_params[custom_param_key] || ""}
                  InputLabelProps={{shrink: true}}
                  sx={{flex: 1}}
                  onChange={(e) => {
                    setNode(prev => {
                      const state = {...prev};
                      if (!state?.data?.custom_params) {
                        state.data.custom_params = {}
                      }
                      state.data.custom_params[custom_param_key] = e.target.value;
                      return state
                    })
                  }}
                  onBlur={() => onUpdate(node)}
                />
                <IconButton
                  onClick={() => {
                    setNode(prev => {
                      const state = {...prev};
                      delete state.data.custom_params[custom_param_key];
                      return state
                    })
                  }}
                >
                  <IconX size={15}/>
                </IconButton>
              </Stack>
            )
          })
      }

    </>
  )
}